import styled from "styled-components"

export const Separator = styled.hr`
  background-color: transparent;
  border-left: 1px solid #bcbaba;
  height: 5.5rem;
  margin: 0;
  ${props => props.hideSeparator && "display: none;"}
  @media ${props => props.theme.device.tablet} {
    /* ${props => props.hideInSmallScreen && "display: none;"} */
    display: none;
  }
`